import { Category, ChevronRight } from '@mui/icons-material'
import { Card, Chip, Tooltip } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import React from 'react'
import { Link } from 'react-router-dom'

const KomponenList = ({ listData, showOpd = false, to = '/', showLastUpdate = false }) => {
    const date = new Date();
    const bulan = date.getMonth()

    const renderItems = listData.map((data, index) => (
        <Card
            key={index}
            component="li"
            sx={{
                mb: 1,
                p: "0 !important"
            }}
        >
            <ArgonBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                borderRadius="lg"
                py={1}
                px={2}
                sx={{
                    m: 0
                }}
            >
                <ArgonBox display="flex" alignItems="center">
                    <ArgonBox
                        display="grid"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius="lg"
                        shadow="md"
                        color="white"
                        width="4rem"
                        height="4rem"
                        mr={2}
                        variant="gradient"
                    >
                        <Category
                            sx={{
                                display: "grid",
                                placeItems: "center",
                            }}
                            fontSize='large'
                            color='primary'
                        />
                    </ArgonBox>
                    <ArgonBox display="flex" flexDirection="column">
                        {
                            showOpd &&
                            <ArgonTypography variant="button" fontWeight="medium" gutterBottom mb={1}>
                                {data.opd.nama_pd}
                            </ArgonTypography>
                        }
                        <ArgonTypography variant="button" fontWeight="medium" gutterBottom mb={1}>
                            {data.nama_komponen}
                        </ArgonTypography>
                        <ArgonTypography variant="caption" color="text" mb={1}>
                            {
                                parseInt(data.anggaran).toLocaleString?.('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                })
                            }
                        </ArgonTypography>
                        <ArgonTypography variant="caption" color="text" mb={1}>
                            {
                                data.uraian_sumber_dana.includes('Dana Alokasi Khusus') &&
                                <Chip
                                    size='small'
                                    variant='outlined'
                                    label='DAK'
                                    color='info'
                                />
                            }
                            {" "}
                            <Chip
                                size='small'
                                variant='outlined'
                                label={
                                    data.status_pelaksanaan
                                } color={
                                    data.status_pelaksanaan === 'Belum Terlaksana' ? 'error' : data.status_pelaksanaan === 'Selesai' ? 'success' : 'primary'
                                }
                            />
                            {" "}
                            {showLastUpdate &&
                                <Chip
                                    size='small'
                                    variant='outlined'
                                    label={
                                        data.laporan_terakhir.bulan === null ? "Realisasi belum dilaporkan" : "Laporan Terakhir Bulan " + data.laporan_terakhir.bulan
                                    } color={
                                        data.status_pelaksanaan === 'Selesai' ? 'success' : (parseInt(data.laporan_terakhir.bulan) < bulan || data.laporan_terakhir.bulan === null) ? 'error' : 'success'
                                    }
                                />
                            }
                        </ArgonTypography>
                    </ArgonBox>
                </ArgonBox>
                <ArgonBox display="flex">
                    <Tooltip title="Selengkapnya" placement="left">
                        <ArgonTypography
                            component={Link}
                            variant="button"
                            // color={color}
                            to={to}
                            state={data.id}
                            sx={{
                                lineHeight: 0,
                                transition: "all 0.2s cubic-bezier(.34,1.61,.7,1.3)",
                                p: 0.5,

                                "&:hover, &:focus": {
                                    transform: "translateX(5px)",
                                },
                            }}
                        >
                            <ChevronRight fontSize='medium' />
                        </ArgonTypography>
                    </Tooltip>
                </ArgonBox>
            </ArgonBox>
        </Card>
    ));

    return (
        <ArgonBox>
            <ArgonBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                {
                    listData.length > 0 ?
                        (
                            renderItems
                        )
                        :
                        (
                            <Card
                                sx={{
                                    mb: 1,
                                    p: 1
                                }}
                            >
                                <ArgonTypography variant="button" fontWeight="medium" mb={1} textAlign='center'>
                                    <em>Tidak ada data</em>
                                </ArgonTypography>
                            </Card>
                        )
                }
            </ArgonBox>
        </ArgonBox>
    )
}

export default KomponenList